export const formatVersionNumber = (version: number) => `v${String(version).padStart(2, '0')}`
